import { Route } from "react-router-dom";
import UserLayout from "../layouts/userLayout";
import MyAccount from "../pages/userAccount";
import MyOrders from "../features/user/userOrders";
import MyPayments from "../features/user/userPayments";
import MyFavorits from "../features/user/userFavorits";
import MyCart from "../features/user/userCart";

export function UserRoutes() {
    return (
        <Route element={<UserLayout />}>
            <Route path="myAccount" element={<MyAccount />} />
            <Route path="myOrders" element={<MyOrders />} />
            <Route path="myBasket" element={<MyCart />} />
            <Route path="myFav" element={<MyFavorits />} />
            <Route path="myPayments" element={<MyPayments />} />
        </Route>
    );
}